/* eslint-disable */
import {
  APP_DATA_PENDING
} from '../modules/applicationData/applicationData.module';
import {setNavConfigData} from '../../utils/nav.utils';

export const injectConfigData = (/* store */) => (next) => (action) => {
  if (action.type === APP_DATA_PENDING) {
    //setAxiosConfigData(action.payload);
    setNavConfigData(action.payload);
  }

  return next(action);
};
/* eslint-enable */
